import React, { useState } from 'react';
import Image from 'next/image';
import styles from '../../../../styles/modules/components/find-plans.module.scss';
import { useDispatch } from 'react-redux';
import Button from '../../../common/ui-components/input/Button';
import UIModal from '../../../common/ui-components/surface/UIModal';
import { cleverTapTrigger } from '../../../../tracking/segment';
import { openDialer } from '../../../../utils';
import { CUSTOMER_CARE_NUMBER } from '../../../../constants';

interface MainProps{
    isOpen: boolean,
    setModal:any,
    setLogoutModalVisible:any
}
const FindPlans = (props: MainProps) => {
  const dispatch = useDispatch();
  const [raiseSRVisible, setRaiseSrVisible] = useState(false);
  const [callUsVisible, setCallUsVisible] = useState(false);
  const [noteVisible, setNoteVisible] = useState(false);
  const [noteNOVisible, setNoteNoVisible] = useState(false);

  const showRaiseSR = () => {
    cleverTapTrigger("Find Plans - Button Clicked",{"CTA":"RAISE REQUEST"})
    setRaiseSrVisible(true);
    setNoteVisible(false);
    setCallUsVisible(false);
   
  };

  const showViewPlan = () => {
    cleverTapTrigger("Find Plans - Button Clicked",{"CTA":"VIEW PLANS"})
    setNoteVisible(true);
    setRaiseSrVisible(false);
    setCallUsVisible(false);
   
  };

  const handleYes = () => {
     cleverTapTrigger("Find Plans - Button Clicked",{"CTA":"YES"})
    setCallUsVisible(true);
    setNoteNoVisible(false);
   
  };

  const handleNo = () => {
    cleverTapTrigger("Find Plans - Button Clicked",{"CTA":"NO"})
    setNoteNoVisible(true);
    setCallUsVisible(false);
  
  };

  const handleCallUs = () => {
    cleverTapTrigger("Find Plans - Button Clicked",{"CTA":"CALL US"})
    openDialer(CUSTOMER_CARE_NUMBER);
  };

 const handleChatWithUs = () => {
    cleverTapTrigger("Find Plans - Button Clicked",{"CTA":"CHAT WITH US"})
    window.location.href = 'https://onst.in/4dCuJA';
  };

  const handleClickHere = () => {
    cleverTapTrigger("Find Plans - Button Clicked",{"CTA":"CLICK HERE"})
    props.setLogoutModalVisible(true);
    props.setModal(false)
  };

  const handleClose = () => {
    cleverTapTrigger("Find Plans - Button Clicked",{"CTA":"CLOSE"})
   props.setModal(false)
  };

  return (
    <UIModal isOpen={props.isOpen} onClick={handleClose} boxClass={styles.apply_box}>
    <div className={styles.container}>
      <div className={styles.header}>
        <h2 className={styles.title}>Find Your Plan</h2>
      </div>

      <div className={styles.content}>
        <p className={styles.query}>Select your query?</p>
        <div className={styles.buttonsRow}>
          <Button text="VIEW PLAN" onClick={showViewPlan} className={styles.buttons1} variant={noteVisible ? 'primary' : 'secondary'}/>
          <Button text="RAISE REQUEST" onClick={showRaiseSR} className={styles.buttons1} variant={raiseSRVisible ? 'primary' : 'secondary'}/>
        </div>

        {raiseSRVisible && (
          <>
            <p className={styles.message}>
              Are you experiencing any issue raising a service request using the mobile number used during plan purchase?
            </p>
            <div className={styles.buttonsRowMessage}>
              <Button text="YES" onClick={handleYes} className={styles.buttons2} variant={callUsVisible ? 'primary' : 'secondary'}/>
              <Button text="NO" onClick={handleNo} className={styles.buttons2} variant={noteNOVisible ? 'primary' : 'secondary'}/>
            </div>
          </>
        )}

        {callUsVisible && (
          <div className={styles.callusDiv}>
            <p className={styles.messageMobile}>Please connect with our agent to create a service request.</p>
            <Button text="CALL US" onClick={handleCallUs}  className={styles.callus}/>
            <Button text="CHAT WITH US" onClick={handleChatWithUs}  className={styles.chatWithus}/>
          </ div>
        )}

        {(noteVisible || noteNOVisible) && (
          <div className={styles.note}>
            <p>
              If your plan isn't visible, log in with the number used at the time of purchase.{' '}
            </p>
            <p className={styles.clickHere} onClick={handleClickHere}>
                Click Here
            </p>
            <p className={styles.noteText}>
              <b className={styles.bold}>Note:</b> If you've recently purchased a plan from a retailer, it may take 3 to 4 days to reflect in your account.
            </p>
          </div>
        )}
      </div>
    </div>
    </UIModal>
  );
};

export default FindPlans;
